import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private monitoringService: MonitoringService) {
    super();
  }

  // Once in the device log: super.handleError writes to console.error, which startMonitoring
  // also copies there, so the developer console gets it through the unwrapped method instead.
  handleError(error: any): void {
    this.monitoringService.nativeConsole.error('ERROR', error);
    this.monitoringService.logException(error, undefined, { source: 'angular' });
  }
}
